import axios from 'axios';
import QueryBuilder from './QueryBuilder';

import properties from '../../../../../../conf/properties';

const rckmsRsEndpoint = `${properties.rsBaseServiceUri}${properties.rsCrudContextPath}/api/resources`.format('rckms');
const cdsRsEndpoint = `${properties.rsBaseServiceUri}${properties.rsCrudContextPath}/api/resources`.format('cds');
const coreRsEndpoint = `${properties.rsBaseServiceUri}${properties.rsCrudContextPath}/api`.format('core');

const MTSClient = (sessionKey = false) => {

    const fromJurisdiction = (jurisdictionId = false) => {

        if (!jurisdictionId) {
            return {
                fetch: () => Promise.reject('No Jurisdiction Id Provded'),
                fetchConditions: () => Promise.reject('No Jurisdiction Id Provded'),
                fetchContacts: () => Promise.reject('No Jurisdiction Id Provded'),
                fetchZipCodes: () => Promise.reject('No Jurisdiction Id Provded')

            };
        } else {
            const fetch = () => {
                return new Promise((resolve, reject) => {
                    let uri = `${rckmsRsEndpoint}/jurisdictions/${jurisdictionId}`;
                    let query = {
                        sessionId: sessionKey
                    };
                    query = QueryBuilder(query);
                    uri += query;
                    axios.get(uri).then(response => {
                        resolve(response.data);
                    }).catch(err => {
                        console.log(err);
                        reject(err);
                    });
                });
            };

            const fetchConditions = () => {
                return new Promise((resolve, reject) => {
                    let uri = `${rckmsRsEndpoint}/jurisdictionconditions`;
                    let query = {
                        filter: `jurisdictionId=${jurisdictionId}`,
                        property: 'queryClass=ByJurisdictionId',
                        sessionId: sessionKey
                    };
                    query = QueryBuilder(query);
                    uri += query;
                    axios.get(uri).then(response => {
                        resolve(response.data);
                    }).catch(err => {
                        console.log(err);
                        reject(err);
                    });
                });
            };

            const fetchUsers = () => {
                return new Promise((resolve, reject) => {
                    let uri = `${rckmsRsEndpoint}/rckmsusers`;
                    let query = {
                        filter: `jurisdictionId=${jurisdictionId}`,
                        property: `queryClass=ByJurisdictionId`,
                        sessionId: sessionKey
                    };
                    query = QueryBuilder(query);
                    uri += query;
                    axios.get(uri).then(response => {
                        resolve(response.data);
                    }).catch(err => {
                        console.log(err);
                        reject(err);
                    });
                });
            };

            const fetchContacts = () => {
                return new Promise((resolve, reject) => {
                    let uri = `${rckmsRsEndpoint}/jurisdictioncontacts`;
                    let query = {
                        filter: `jurisdictionId=${jurisdictionId}`,
                        property: `queryClass=ByJurisdictionId`,
                        sessionId: sessionKey
                    };
                    query = QueryBuilder(query);
                    uri += query;
                    axios.get(uri).then(response => {
                        resolve(response.data);
                    }).catch(err => {
                        console.log(err);
                        reject(err);
                    });
                });
            };

            const fetchZipCodes = () => {
                return new Promise((resolve, reject) => {
                    let uri = `${rckmsRsEndpoint}/jurisdictionzipcodes`;
                    let query = {
                        filter: `jurisdictionId=${jurisdictionId}`,
                        property: `queryClass=ByJurisdictionId`,
                        sessionId: sessionKey
                    };
                    query = QueryBuilder(query);
                    uri += query;
                    axios.get(uri).then(response => {
                        resolve(response.data);
                    }).catch(err => {
                        console.log(err);
                        reject(err);
                    });
                });
            };

            return {
                fetch,
                fetchConditions,
                fetchUsers,
                fetchContacts,
                fetchZipCodes
            };
    }
    };

    const fromDefault = () => {

        const fetchConditions = () => {
            return new Promise((resolve, reject) => {
                let uri = `${rckmsRsEndpoint}/conditions`;
                let query = {
                    filter: `business_id=RCKMS,scoping_entity_id=gov.cdc.rckms.default`,
                    property: `queryClass=ByBusinessScopingVersion`,
                    sessionId: sessionKey
                };
                query = QueryBuilder(query);
                uri += query;
                axios.get(uri).then(response => {
                    resolve(response.data);
                }).catch(err => {
                    console.log(err);
                    reject(err);
                });
            });
        };

        /*
            GET /mts-rs-rckms/api/resources/rckmsusers?property=queryClass%3DFindAl
Host: cds.hln.com
Connection: keep-alive
        X-Requested-With: XMLHttpRequest
        User-Agent: Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/80.0.3970.5 Safari/537.36
        Sec-Fetch-Site: same-origin
        Sec-Fetch-Mode: cors
        Referer: https://cds.hln.com/cat-rckms-bs/rckmsusers/
            Accept-Encoding: gzip, deflate, br
        Accept-Language: en-US,en;q=0.9
        Cookie: _ga=GA1.2.53804055.1569960872; _gid=GA1.2.1531546746.1574372623

        */

        const fetchUserAccounts = () => {
            return new Promise((resolve, reject) => {
                let uri = `${rckmsRsEndpoint}/rckmsusers`;
                let query = {
                    property: `queryClass=FindAll`,
                    sessionId: sessionKey
                };
                query = QueryBuilder(query);
                uri += query;
                axios.get(uri).then(response => {
                    resolve(response.data);
                }).catch(err => {
                    console.log(err);
                    reject(err);
                });
            });
        };


        return {
            fetchConditions,
            fetchUserAccounts
        };
    };

    const fetchAllJurisdictions = () => {
        return new Promise((resolve, reject) => {
            let uri = `${rckmsRsEndpoint}/jurisdictions`;
            let query = {
                property: 'queryClass=FindAll',
                sessionId: sessionKey
            };
            query = QueryBuilder(query);
            uri += query;
            axios.get(uri).then(response => {
                resolve(response.data);
            }).catch(err => {
                console.log(err);
                reject(err);
            });
        });
    };

    const fromCondition = (conditionId = false) => {
          if (!conditionId) {
              return Promise.reject('No Condition Id Provided');
          } else {
              const fetch = () => {
                  return new Promise((resolve, reject) => {
                      let uri = `${rckmsRsEndpoint}/conditions/${conditionId}`;
                      let query = {
                          sessionId: sessionKey
                      };
                      query = QueryBuilder(query);
                      uri += query;
                      axios.get(uri).then(response => {
                          resolve(response.data);
                      }).catch(err => {
                          console.log(err);
                          reject(err);
                      });
                  });
              };

              const fetchConceptsByCondition = () => {
                  return new Promise((resolve, reject) => {
                      let uri = `${cdsRsEndpoint}/concepts`;
                      let query = {
                          property: `queryClass=ByConditionId`,
                          expand: `OpenCdsConceptRelDTO[deployment_environment=PRODUCTION]`,
                          filter: `conditionId=${conditionId}`,
                          sessionId: sessionKey
                      };
                      query = QueryBuilder(query);
                      uri += query;
                      uri += `&expand=ValueSetCdsCodeRelDTO`;
                      axios.get(uri).then(response => {
                          resolve(response.data);
                      }).catch(err => {
                          console.log(err);
                          reject(err);
                      })
                  });
              };


            const fetchLinksAndReferences = (scope = 'EXTERNAL') => {
                return new Promise((resolve, reject) => {
                    let uri = `${rckmsRsEndpoint}/conditionreferences`;
                    let query = {
                        filter: `conditionId=${conditionId},scope=${scope}`,
                        property: "queryClass=ByConditionIdScope",
                        sessionId: sessionKey
                    };
                    if (scope === 'BOTH') {
                        query = {
                            ...query,
                            ...{
                                    filter: `conditionId=${conditionId}`,
                                    property: 'queryClass=ByConditionId'
                                }
                            };
                        }
                        query = QueryBuilder(query);
                        uri += query;
                        axios.get(uri).then(response => {
                            resolve(response.data);
                        }).catch(err => {
                            console.log(err);
                            reject(err);
                        })
                    });
              };

              const fetchSpecifications = () => {
                  return new Promise((resolve, reject) => {
                      let uri = `${rckmsRsEndpoint}/conditionspecifications`;
                      let query = {
                          filter: `conditionId=${conditionId}`,
                          property: `queryClass=ByConditionId`,
                          sessionId: sessionKey
                      };
                      query = QueryBuilder(query);
                      uri += query;
                      axios.get(uri).then(response => {
                          resolve(response.data);
                      }).catch(err => {
                          console.log(err);
                          reject(err);
                      })
                  });
              };

              const fetchLogicSets = () => {
                  return new Promise((resolve, reject) => {
                      let uri = `${rckmsRsEndpoint}/logicsets`;
                      let query = {
                          filter: `conditionId=${conditionId}`,
                          property: `queryClass=ByConditionId`,
                          sessionId: sessionKey
                      };
                      query = QueryBuilder(query);
                      uri += query;
                      axios.get(uri).then(response => {
                          resolve(response.data);
                      }).catch(err => {
                          console.log(err);
                          reject(err);
                      })
                  });
              };

              const fetchCriteriaRels = () => {
                  return new Promise((resolve, reject) => {
                      let uri = `${rckmsRsEndpoint}/conditioncriteriarels`;
                      let query = {
                          filter: `conditionId=${conditionId}`,
                          property: `queryClass=ByConditionId`,
                          sessionId: sessionKey
                      };
                      query = QueryBuilder(query);
                      uri += query;
                      axios.get(uri).then(response => {
                          resolve(response.data);
                      }).catch(err => {
                          console.log(err);
                          reject(err);
                      })
                  });
              };

            return {
                fetch,
                fetchCriteriaRels,
                fetchLinksAndReferences,
                fetchLogicSets,
                fetchSpecifications,
                fetchConceptsByCondition
            };
    }
    };

    if (!sessionKey) {
        return {
            fromJurisdiction: () => Promise.reject('No Session Key Provided'),
            fromDefault: () => Promise.reject('No Session Key Provided'),
            fetchAllJurisdictions: () => Promise.reject('No Session Key Provided'),
            fromCondition: () => Promise.reject('No Session Key Provided'),
        };
    } else {
        return {
            fromJurisdiction,
            fromDefault,
            fetchAllJurisdictions,
            fromCondition,
        };
}
};

export default MTSClient;
